"use client";

import { usePathname } from "next/navigation";
import { GoogleAnalytics } from "@next/third-parties/google";

const GA_MEASUREMENT_ID = "G-LX2TN7P4N2";

/** 어드민(/admin/*)은 대표 본인만 쓰는 내부 화면이라 GA 수집 대상에서 제외한다(대표 지시,
 * 2026-09-17) — 로케일 프리픽스(/ko, /en, /zh)만 떼고 판단해야 하므로 pathname 원문에서
 * "/admin" 포함 여부로 검사(로케일이 앞에 붙어도 "/ko/admin/..." 형태라 그대로 매칭된다). */
export default function Analytics() {
  const pathname = usePathname();
  if (pathname?.includes("/admin")) return null;
  return <GoogleAnalytics gaId={GA_MEASUREMENT_ID} />;
}
